/**
 * Woo Cart Ajax
 * ======================================
 * - add cart counter after page load
 * - you can use cache plugins now
 */

 const ELEMENTS = '.woo-cart'
 const ELEMENT_COUNTER = '.woo-cart__counter'
 const LOADING_CLASS = 'loading'

 class WooCart {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS)
     this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

     window.addEventListener('load', this.loadHandler)
   }

   loadHandler = () => {
     const xhr = new XMLHttpRequest()
     xhr.open('POST', this.ajaxUrl, true)
     xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
     xhr.send("action=WooCart");

     xhr.onreadystatechange = () => {
       if (xhr.readyState === 4) {
         // ok
         if (xhr.status === 200) {
           const response = JSON.parse(xhr.responseText)

           this.elements.forEach(el => {
             const counterEl = el.querySelector(ELEMENT_COUNTER)

             counterEl.innerHTML = response.count
             el.classList.remove(LOADING_CLASS)
           })
         }
         // error
         else {
           console.log('ajaxForm error!', xhr)
         }
       }
     }

   }
 }

 new WooCart()
